import * as Yup from 'yup';

import { isValidEmail, isValidPhone } from '../../../lib/helpers/validation.helpers';

export const otpRequestValidationSchema = Yup.object().shape({
  identifier: Yup.string()
    .required('Enter your email or phone number')
    .test(
      'email-or-phone',
      'Enter a valid email or phone number',
      (value) => !!value && (isValidEmail(value) || isValidPhone(value)),
    ),
});

export const otpVerifyValidationSchema = Yup.object().shape({
  code: Yup.string()
    .required('Enter the code we sent you')
    .matches(/^\d{6}$/, 'The code is 6 digits'),
});
